import { PinosTerritorioQueryInput } from 'graphql/types.generated'

import { convertMicroareasFilterFormModelToFilterModel, convertVisualizacaoMicroareaFilterToInput } from '../converter'
import { TerritorioMapaBuscaFormModel } from './mapa-busca/model-territorioMapaBusca'

export function convertFilterToQueryInput(values: TerritorioMapaBuscaFormModel): PinosTerritorioQueryInput {
  const { animaisImovel, condicoesMoradia, ...filtrosAvancadosInput } = convertVisualizacaoMicroareaFilterToInput(
    convertMicroareasFilterFormModelToFilterModel(values.filtrosAvancados)
  )

  return {
    cnes: values.unidadeSaude!.cnes,
    ine: values.equipe!.ine,
    microarea: values.microareas,
    animaisImovelInput: animaisImovel,
    condicoesMoradiaInput: condicoesMoradia,
    ...filtrosAvancadosInput,
  }
}
